import React from 'react'

import {H3, H5, P, Row, Button, Alert, Popup} from '../../../../components/UI/index.js'
import {FormStack, Toggle, Input, Select} from '../../../../components/UI/forms/index.js'
import LoginActions from '../../../../actions/LoginActions.js'

class CCVShopSettings extends React.Component {
    constructor(props) {
        super(props)

        this.state = {error: ''}
    }

    onChangeChecked(key, event) {
        const {user, onChange} = this.props

        user.settings.webshops.ccvshop[key] = event.target.checked

        onChange(user)
    }

    onChangeValue(key, event) {
        const {user, onChange} = this.props

        user.settings.webshops.ccvshop[key] = event.target.value

        onChange(user)
    }

    onChangeValues(key, event) {
        const {user, onChange} = this.props

        user.settings.webshops.ccvshop[key] = event.target.values

        onChange(user)
    }

    onVerifyConnection() {
        const {user, onChange} = this.props

        this.setState({loading: true, message: '', error: ''})

        onChange(user, true, () => {
            LoginActions.verifyWebshop('ccvshop', (err) => {
                if (err) {
                    this.setState({loading: false, error: `Verificatie niet succesvol, controleer de ingevulde gegevens. Foutmelding: ${err}`})
                } else {
                    this.setState({loading: false, error: '', message: 'Verificatie succesvol'})
                }
            })
        })
    }

    async onCreateWebhook() {
        const {user, onChange} = this.props

        if (!await this.popup.open('Automatisch importeren activeren', 'Het automatisch importeren van bestellingen wordt geactiveerd.')) return

        onChange(user, true, () => {
            LoginActions.createWebshopWebhook('ccvshop', (err) => {
                if (err) {
                    this.popup.setError(`Webhook activeren niet succesvol, controleer de ingevulde gegevens. Foutmelding: ${err}`)
                } else {
                    this.popup.close()
                    this.setState({message: 'Webhook aangemaakt'})
                }
            })
        })
    }

    async onDeleteWebhook() {
        const {user, onChange} = this.props

        if (!await this.popup.open('Automatisch importeren deactiveren', 'Het automatisch importeren van bestellingen wordt gedeactiveerd.')) return

        onChange(user, true, () => {
            LoginActions.deleteWebshopWebhook('ccvshop', (err) => {
                if (err) {
                    this.popup.setError(`Webhook deactiveren niet succesvol, controleer de ingevulde gegevens. Foutmelding: ${err}`)
                } else {
                    this.popup.close()
                    this.setState({message: 'Webhook verwijderd'})
                }
            })
        })
    }

    render() {
        const {user} = this.props
        const {error, message, loading} = this.state

        return (
            <div>
                <H3 style={{marginBottom: 36}}>CCV Shop</H3>

                <H5 style={{marginBottom: 24}}>Instellingen</H5>

                <FormStack>
                    <Toggle
                        label='Actief'
                        checked={user.settings.webshops.ccvshop.active}
                        onChange={this.onChangeChecked.bind(this, 'active')}
                    />

                    {user.settings.webshops.ccvshop.active &&
                        <>
                            <Input
                                label='Webshop URL'
                                value={user.settings.webshops.ccvshop.url}
                                onChange={this.onChangeValue.bind(this, 'url')}
                            />

                            <Input
                                label='API Key'
                                info='Deze kun je aanmaken in je CCV Shop omgeving.'
                                value={user.settings.webshops.ccvshop.apiKey}
                                onChange={this.onChangeValue.bind(this, 'apiKey')}
                            />

                            <Input
                                label='API Secret'
                                info='Deze kun je aanmaken in je CCV Shop omgeving.'
                                value={user.settings.webshops.ccvshop.apiSecret}
                                onChange={this.onChangeValue.bind(this, 'apiSecret')}
                            />

                            <Select
                                label='Update bestelling status in CCV Shop'
                                info=''
                                value={user.settings.webshops.ccvshop.updateStatus}
                                onChange={this.onChangeValue.bind(this, 'updateStatus')}
                            >
                                <option value=''>Nooit</option>
                                <option value='confirm'>Na bevestigen</option>
                                <option value='afterSent'>Na verzenden</option>
                            </Select>

                            <Select
                                label='Haal productinformatie op'
                                info=''
                                value={user.settings.webshops.ccvshop.includeProducts}
                                onChange={this.onChangeValue.bind(this, 'includeProducts')}
                            >
                                <option value='always'>Ja</option>
                                <option value='nonEU'>Alleen voor douane landen</option>
                                <option value='never'>Nee</option>
                            </Select>

                            <Select
                                label='Importeer bestellingen met status'
                                info='Selecteer de statussen waarvoor bestellingen worden geïmporteerd'
                                options={[
                                    {value: '1', title: 'Nieuw'},
                                    {value: '2', title: 'In behandeling'},
                                    {value: '3', title: 'Wachten op fabrikant'},
                                    {value: '4', title: 'Wachten op betaling'},
                                    {value: '9', title: 'Wachten op leverancier'},
                                    {value: '10', title: 'Wordt verpakt'},
                                    {value: '12', title: 'Wordt geassembleerd'},
                                    {value: '13', title: 'Backorder'},
                                    {value: '14', title: 'Gereserveerd'}
                                ]}
                                values={user.settings.webshops.ccvshop.statuses || []}
                                onChange={(event) => this.onChangeValues('statuses', event)}
                            />

                            <Toggle
                                label='Alleen betaalde bestellingen importeren'
                                checked={user.settings.webshops.ccvshop.ignoreNotPayedOrders}
                                onChange={(event) => this.onChangeChecked('ignoreNotPayedOrders', event)}
                            />

                            <Row style={{flexShrink: 0, alignItems: 'center'}}>
                                <P style={{flex: 1}}>Bestellingen automatisch importeren</P>

                                {user.settings.webshops.ccvshop.webhookId ?
                                    <Button
                                        variant='outline'
                                        onClick={() => this.onDeleteWebhook()}
                                    >
                                        Deactiveren
                                    </Button> :
                                    <Button
                                        variant='outline'
                                        onClick={() => this.onCreateWebhook()}
                                    >
                                        Activeren
                                    </Button>
                                }
                            </Row>

                            <Button
                                variant='text'
                                loading={loading}
                                onClick={this.onVerifyConnection.bind(this)}
                            >
                                Verifieer
                            </Button>

                            {error && (
                                <Alert style={{marginBottom: 6}} onClose={() => this.setState({error: ''})} variant='error'>{error}</Alert>
                            )}

                            {message && (
                                <Alert style={{marginBottom: 6}} onClose={() => this.setState({message: ''})}>{message}</Alert>
                            )}
                        </>
                    }
                </FormStack>

                <Popup ref={(ref) => this.popup = ref} />
            </div>
        )
    }
}

export default CCVShopSettings
